$(function() {
	if (/Trident\//.test(navigator.userAgent))
		$('body').addClass('trident');
});
